<template>
  <div>
    <!-- LIST VIEW -->

    <v-list-item three-line v-if="!gridView" dense :class="mediaTypeColor">
      <v-list-item-icon>
        <v-icon medium>square_foot</v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title class="subtitle-1">
          <span v-html="descriptionText"></span>
        </v-list-item-title>
        <v-list-item-subtitle
          >{{ mediaTypeDescription }}
          <span
            v-if="
              media.mediaTypeId !== mediaTypesEnum.poi_image ||
                media.mediaTypeId !== mediaTypesEnum.poi_image_dzi
            "
            >{{ mediaDetailsDescription }}</span
          ></v-list-item-subtitle
        >
        <v-list-item-subtitle>{{ media.url }}</v-list-item-subtitle>
        <v-list-item-subtitle>{{ media.mediaData.path }}</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <div class="text-xs-right">
          <!-- <v-btn
            icon
            color="orange"
            v-on:click="openAddToGalleryDialog()"
            title="Add to Gallery"
          >
            <v-icon>mdi-image-album</v-icon>
          </v-btn> -->
          <v-btn
            icon
            v-on:click="removeMediaItem()"
            color="error"
            title="Delete"
          >
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
          <v-btn icon v-on:click="edit()" title="Edit">
            <v-icon>edit</v-icon>
          </v-btn>
        </div>
      </v-list-item-action>
    </v-list-item>
    <v-divider v-if="!gridView">&nbsp;</v-divider>

    <!-- GRID VIEW -->
    <v-card
      class="mx-auto"
      :color="mediaTypeColor"
      max-width="250"
      v-if="gridView"
    >
      <v-list-item>
        <v-list-item-avatar color="grey">
          <v-icon medium>square_foot</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="subtitle-1">{{
            mediaTypeDescription
          }}</v-list-item-title>
          <v-list-item-subtitle>
            {{ mediaDetailsDescription }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-card-text class="text-truncate">
        <span v-html="media.mediaData"></span>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn icon v-on:click="removeMediaItem()" color="error" title="Delete">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
        <v-btn icon v-on:click="edit()" title="Edit">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>

    <add-to-gallery-dialog
      v-if="showAddToGalleryDialog"
      :showDialog="showAddToGalleryDialog"
      @cancel="closeAddToGalleryDialog"
      @done="closeAddToGalleryDialog"
    ></add-to-gallery-dialog>
  </div>
</template>

<script>
import AddToGalleryDialog from '../AddToGalleryDialog'
import Enums from '../../helpers/Enums'

export default {
  components: {
    AddToGalleryDialog
  },
  props: {
    media: {
      type: Object,
      required: true,
      default: function() {
        return {}
      }
    },
    gridView: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    }
  },

  created: function() {
    this.getMediaContent(this.$props.media)
  },
  computed: {
    showAddToGalleryDialog: {
      get: function() {
        return this.showDialog
      },
      set: function(newValue) {
        this.showDialog = newValue
      }
    }
  },
  methods: {
    edit() {
      var self = this
      this.$store
        .dispatch('MediaStore/setSelectedMediaItem', this.media.id, {
          root: true
        })
        .then(res => {
          self.$emit('edit', this.media.id)
        })
    },
    getMediaContent: function(media) {
      this.name = media.name

      this.mediaTypesEnum = Enums.MediaType

      this.mediaTypeDescription = 'Unity Component'
      if (media.mediaTypeId === Enums.MediaType.unity_link_component) {
        this.mediaTypeDescription = 'Unity Link Component'
      } else if (
        media.mediaTypeId === Enums.MediaType.unity_serialize_component
      ) {
        this.mediaTypeDescription = 'Unity Serialize Component'
      }

      this.mediaDetailsDescription = Enums.lang[media.langId].name

      let transform = { '<>': 'div', text: 'Link ID: ${linkID}' }
      //this.descriptionText =  json2html.transform(media.mediaData,transform);
    },
    async removeMediaItem() {
      if (this.media.id) {
        await this.$confirm({
          title: 'Delete',
          text: 'Are you sure?',
          acceptText: 'DELETE',
          cancelText: 'CANCEL'
        })
        await this.$store.dispatch('MediaStore/deleteMedia', [this.media.id])
        await this.checkRequiredMediaItemsExist()
      }
    },
    async checkRequiredMediaItemsExist() {
      if (this.mediaContext === 'poi') {
        await this.$store.dispatch('PoiStore/checkPoiHasRequiredMediaItems')
      } else if (this.mediaContext === 'project') {
        await this.$store.dispatch(
          'ProjectStore/checkProjectHasRequiredMediaItems'
        )
      }
    },
    openAddToGalleryDialog: async function() {
      if (!this.showAddToGalleryDialog) {
        await this.$store.dispatch(
          'MediaStore/setSelectedMediaItem',
          this.media.id
        )
        await this.$store.dispatch(
          'MediaStore/getSelectedMediaItemParentGalleries'
        )
        this.showAddToGalleryDialog = true
      }
    },
    closeAddToGalleryDialog: function() {
      if (this.showAddToGalleryDialog) {
        this.showAddToGalleryDialog = false
      }
    }
  },
  data: function() {
    return {
      name: '',
      bannerImageUrl: './assets/default_file_icon.png',
      descriptionText: '',
      mediaTypeDescription: '',
      mediaDetailsDescription: '',
      mediaFileDescription: '',
      showDialog: false,
      mediaTypeColor: 'gray darken-1'
    }
  }
}
</script>

<style scoped>
.media-card-title {
}
.media-card-description {
}
.media-card-image {
}
.text-xs-right {
  white-space: nowrap;
}
</style>
